(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("ELEMENT", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["ELEMENT"] = factory(require("vue"));
	else
		root["ELEMENT"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__2__) {
return 